module.exports = __webpack_public_path__ + "img/id-shape-1.20af051c.svg";